import { get, writable } from "svelte/store";
import { LayerListItemGroupManager } from "./LayerListItemGroupManager";
export class LayersControlManager {
    constructor(modelViewManager) {
        this.collapsedStore = writable(true);
        this.layerListItemGroupManagerStore = writable([]);
        this.oneLayerStore = writable(true);
        this.showCyclingScoreToggleStore = writable(true);
        this.modelViewManager = modelViewManager;
        this.modelTranslationKeyStore = this.modelViewManager.getModelTranslationKeyStore();
        this.showCyclingScoreStore = this.modelViewManager.getShowCyclingScoreStore();
        this.showRelevantLocationsStore = this.modelViewManager.getShowRelevantLocationsStore();
        this.showRelevantLocationsToggleStore = this.modelViewManager.getShowRelevantLocationsToggleStore();
        this.modelViewManager.getLayersAndStatusStore().subscribe(layers => {
            const layersPerVehicle = new Map();
            layers.forEach(l => {
                var _a;
                let group = ((_a = l.layer.properties) !== null && _a !== void 0 ? _a : {})["group"];
                if (typeof group === "undefined") {
                    group = l.vehicle.id;
                }
                if (layersPerVehicle.has(group)) {
                    layersPerVehicle.get(group).push(l);
                }
                else {
                    layersPerVehicle.set(group, [l]);
                }
            });
            const groups = [];
            layersPerVehicle.forEach((layers, k) => {
                groups.push({ layers: layers, key: k });
            });
            this.layerListItemGroupManagerStore.set(groups.map((l) => {
                return new LayerListItemGroupManager(this, l.key, l.layers, groups.length === 1);
            }));
            this.oneLayerStore.set(layers.length === 1);
        });
    }
    getShowCyclingScoreToggleStore() {
        return this.showCyclingScoreToggleStore;
    }
    getShowCyclingScoreStore() {
        return this.showCyclingScoreStore;
    }
    getShowRelevantLocationsToggleStore() {
        return this.showRelevantLocationsToggleStore;
    }
    getShowRelevantLocationsStore() {
        return this.showRelevantLocationsStore;
    }
    getOneLayerStore() {
        return this.oneLayerStore;
    }
    getModelTranslationKeyStore() {
        return this.modelTranslationKeyStore;
    }
    onToggleCollapsed() {
        this.collapsedStore.set(!get(this.collapsedStore));
    }
    getCollapsedStore() {
        return this.collapsedStore;
    }
    getLayerListItemGroupManagerStore() {
        return this.layerListItemGroupManagerStore;
    }
}
